// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"277":"b2336946","970":"f1f13de8"}[chunkId] + ".chunk.css";
};